<div fxFill fxLayout="column" fxLayoutAlign="start center">
  <app-header-noauth class="appHeader appHeader--sticky appHeader--noauth"></app-header-noauth>
  <mat-card>
    <mat-card-title><h1 class="title">FAQS ACCESIBILIDAD Web's Sabadell Consumer</h1></mat-card-title>
    <div class="content">
      <h3>1. ¿Puedes contratar un préstamo en SCF de forma Accesible?</h3>
      <ul>
        <li>
          Aún no. Con nuestros procesos on-line de Sabadell Consumer en breve podrás solicitar un préstamo de forma
          accesible. Nuestra previsión es en Julio tener adaptados estos procesos.
        </li>
      </ul>
      <h3>2. ¿Puedo consultar mis datos referentes a una financiación de forma Accesible?</h3>
      <ul>
        <li>Si. Nuestra Web Cliente ya se ha adaptado para que se navegue de forma accesible.</li>
      </ul>

      <h3>3. ¿Puedo acceder a información de Sabadell Consumer de forma accesible?</h3>
      <ul>
        <li>Aún no. La Web informacional se está renovando por completo para que sea totalmente accesible.</li>
      </ul>

      <h3>4. ¿No puedo obtener la información por la web, a donde puedo dirigir-me para conseguirla?</h3>
      <ul>
        <li>
          Estamos trabajando para que próximamente pueda obtener toda la información a través de la web, mientras tanto,
          puede llamar al <strong>93 400 43 02</strong> , donde la informaran.
        </li>
      </ul>

      <h3>5. ¿En qué estamos mejorando las Webs públicas de Sabadell Consumer a nivel de Accesibilidad?</h3>
      <ul>
        <li>
          Las Webs de Sabadell Consumer se ha realizado una auditoría externa para verificar el nivel de Accesibilidad.
          Se han detectado varios puntos de mejora que se en estos momentos se están ajustando para que las Webs tengan
          la Certificación de Accesibilidad.
        </li>
      </ul>

      <h3>6. ¿Qué tipo de mejoras se están acometiendo a nivel de Accesibilidad en las Web's?</h3>
      <ul>
        <li>
          Entre varias mejoras, se están adaptando las páginas para que las imágenes y Logotipos tengan una alternativa
          contextual. o Se están alineando las estructuras de las páginas para que tengan una jerarquía de bloques
          lógica y los lectores de audio puedan navegar correctamente. o Se están revisando y adaptando los colores que
          aparecen para que tengan un contraste que no de problemas a nivel visual. o Se están mejorando la navegación
          por Teclado para no limitar el uso del Mouse.
        </li>
      </ul>
    </div>
  </mat-card>
  <!-- FOOTER -->
  <app-footer class="appFooter appFooter--noauth"></app-footer>
</div>
